// @flow
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from '../../../utils'

export { BeforeButtonWrapper } from '../PaymentMethodsList/elements'

export const ButtonContainer = styled('div', {
  width: '100%',
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  marginTop: '20px',
  marginBottom: '30px',
  ...getScreenStyles('xs', {
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    marginBottom: '15px',
  }),
})
